export const environment = {
  production: false,
  basePath: 'https://api.dev.force-logistic.pl',
  apiPostfix: '',
};
